import angular from 'angular';
import { MeurhContribuintesIndividuaisFormController } from './contribuintesindividuais.form.controller';

export class MeurhContribuintesIndividuaisFormComponent implements angular.IComponentOptions {
    static selector = 'meurhContribuintesIndividuaisFormComponent';
    static controller = MeurhContribuintesIndividuaisFormController;
    static template = require('!!html-loader!./contribuintesindividuais.form.html');
    static transclude = true;
    static bindings = {
        entity: '=',
        form: '<?',
        editable: '<',
    };
}
